import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { SparklesIcon, FrownIcon, SmileIcon, CircleDotIcon, HeartIcon, ChevronsUpIcon, SunIcon, SquareIcon, ShirtIcon } from 'lucide-react';
const areas = [{
  name: 'Facial Volume Loss',
  description: 'Sculptra can restore volume and fullness to areas of the face that have experienced volume loss like the cheeks, temples and under-eye hollows.',
  icon: SparklesIcon
}, {
  name: 'Marionette Lines',
  description: 'Sculptra can soften and diminish the appearance of the lines that extend from the corners of the mouth to the chin, known as marionette lines.',
  icon: FrownIcon
}, {
  name: 'Nasolabial Folds',
  description: 'Sculptra can help reduce the prominence of the lines that run from the nose to the corners of the mouth, known as nasolabial folds.',
  icon: SmileIcon
}, {
  name: 'Temple Volume Loss',
  description: 'Sculptra can replenish lost volume in the temples, which can hollow with age, providing a more youthful appearance.',
  icon: CircleDotIcon
}, {
  name: 'Cheeks',
  description: 'Sculptra can enhance cheek volume and improve overall facial contour for a lifted and more youthful look with long-lasting, natural results.',
  icon: HeartIcon
}, {
  name: 'Booty Enhancement',
  description: 'Sculptra can be used for non-surgical booty enhancement, providing subtle volume and lift to achieve a more sculpted appearance. It also adds roundness and fullness to the butt and significantly improves the appearance of cellulite.',
  icon: ChevronsUpIcon
}, {
  name: 'Smile Lines',
  description: "Sculptra injections can minimize the appearance of smile lines or 'parentheses lines' around the mouth, helping to achieve a smoother and rejuvenated appearance.",
  icon: SunIcon
}, {
  name: 'Jawline',
  description: 'Sculptra can provide subtle reshaping and contouring along the jawline, improving definition and symmetry. It can also help restore lost volume in that area.',
  icon: SquareIcon
}, {
  name: 'Décolletage',
  description: 'Sculptra can rejuvenate and improve the appearance of the skin on the chest and décolletage, reducing wrinkles and creases caused by aging or sun damage.',
  icon: ShirtIcon
}];
export function SCWhereUsed() {
  return <section className="bg-[#ECECEC] py-[60px] lg:py-[100px]" data-id="element-1885">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-1886">
        <AnimateOnScroll className="text-center flex flex-col items-center mb-12" data-id="element-1887">
          <span className="text-[#FF1493] uppercase text-sm font-bold tracking-[3px] mb-4 font-[Poppins,_sans-serif]" data-id="element-1888">
            Be INSPIRED
          </span>

          <h2 className="text-[28px] lg:text-[44px] uppercase text-black leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-1889">
            WHERE IT CAN BE USED
          </h2>

          <div className="space-y-6 text-[#333333] text-[17px] leading-[1.7] font-body max-w-[800px] mb-6" data-id="element-1890">
            <p data-id="element-1891">
              Sculptra can be used to restore the face (or body's) collagen
              framework for a more youthful appearance. For cosmetic concerns
              like loose skin on the chest and décolleté, Sculptra injections
              can help stimulate collagen production, leading to a tightening
              and lifting effect. By adding volume and improving skin quality,
              it may enhance the appearance of these areas.
            </p>
            <p data-id="element-1892">
              For buttock enhancement, Sculptra injections provide a subtle
              volumizing effect that can lift and tone the skin, enhancing the
              shape you desire. From head to toe, Sculptra can be safely used
              for easing the signs of aging.
            </p>
          </div>

          <div className="w-[40px] h-[2px] bg-[#FF1493]" data-id="element-1893"></div>
        </AnimateOnScroll>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1894">
          {areas.map((area, index) => <AnimateOnScroll key={index} delay={index * 60} data-id="element-1895">
              <div className="bg-white p-7 shadow-[0_4px_16px_rgba(0,0,0,0.06)] h-full group hover:shadow-[0_8px_24px_rgba(0,0,0,0.1)] transition-shadow duration-300" data-id="element-1896">
                <area.icon size={36} strokeWidth={1.5} className="text-[#FF1493] mb-4 group-hover:scale-110 transition-transform duration-300" data-id="element-1897" />
                <h3 className="text-black text-lg font-bold font-[Poppins,_sans-serif] mb-2" data-id="element-1898">
                  {area.name}
                </h3>
                <p className="text-[#666666] text-sm leading-[1.6] font-body" data-id="element-1899">
                  {area.description}
                </p>
              </div>
            </AnimateOnScroll>)}
        </div>
      </div>
    </section>;
}